<div class="toast-container position-fixed top-5 end-0 p-3" style="z-index: 1055;">
    <ngb-toast *ngIf="showToast" [autohide]="true" [delay]="1500" class="bg-success text-white">
      {{ toastMessage }}
    </ngb-toast>
  </div>
  
  <router-outlet></router-outlet>
  